import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';
import { MobileNotAvailableScreen } from '@/components/shell/mobile-not-available-screen';
import { useMediaMinDesktop } from '@/hooks/use-media-min-width';

const DEFAULT_DOCUMENT_TITLE = 'SMB-Cut — Browser Video Editor';
const HOME_DOCUMENT_TITLE = 'SMB-Cut — Browser Video Editor';

function RootLayout() {
  const desktop = useMediaMinDesktop();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    if (pathname === '/') {
      document.title = HOME_DOCUMENT_TITLE;
    } else if (pathname === '/blog' || pathname.startsWith('/blog/')) {
      /* Blog routes set title + meta via useDocumentSeo */
    } else {
      document.title = DEFAULT_DOCUMENT_TITLE;
    }
  }, [pathname]);

  // Auth popup callback runs in a tiny popup window (~520px wide) that
  // would otherwise trip the mobile gate. Skip the entire shell for it —
  // the route closes itself in ~200ms.
  if (pathname === '/auth-popup-callback') {
    return <Outlet />;
  }

  if (!desktop) {
    return <MobileNotAvailableScreen />;
  }

  return <Outlet />;
}

export const Route = createRootRoute({
  component: RootLayout,
});
